export class RegularExpressionsUtility {
  // matches the following in a string: (CM)
  // 12345
  // .12345
  // 12345.12345
  // 0.12345
  // but not 1.1.1
  static matchDecimalChars(string: string) {
    return string.match(/\d*\.*\d+/);
  }

  // matches the following in a string: (CM)
  // '<='
  // '>='
  // '<'
  // '>'
  static matchComparisonOperatorChars(string: string) {
    return string.match(/<=|>=|<|>/);
  }

  // Matches normal people first name and last name
  // no special characters like @#$%^&*+=!?[]{}()\/_<>...
  // no number
  // can contain - and '
  // begin with a word, or -, or '
  // at least one character length
  // get more explanation on https://regexr.com/
  static peopleNameRegexCtr() {
    return new RegExp(/^[\w'\-][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{0,}$/, 'gi');
  }
}
